/* eslint-disable import/prefer-default-export */

export { default as ContainerCards } from './ContainerCardsWrapperConnector';
